import n from "highlight.js/lib/languages/javascript";
import r from "highlight.js/lib/languages/typescript";
import e from "highlight.js/lib/languages/csharp";
import t from "highlight.js/lib/languages/go";
import i from "highlight.js/lib/languages/http";
import o from "highlight.js/lib/languages/ini";
import a from "highlight.js/lib/languages/java";
import l from "highlight.js/lib/languages/perl";
import g from "highlight.js/lib/languages/php";
import h from "highlight.js/lib/languages/properties";
import s from "highlight.js/lib/languages/python";
import c from "highlight.js/lib/languages/ruby";
import d from "highlight.js/lib/languages/rust";
import u from "highlight.js/lib/languages/scala";
import p from "highlight.js/lib/languages/swift";
import f from "highlight.js/lib/languages/kotlin";
import m from "highlight.js/lib/languages/objectivec";
import b from "highlight.js/lib/languages/dart";
import y from "highlight.js/lib/languages/bash";
import v from "highlight.js/lib/languages/shell";
import k from "highlight.js/lib/languages/sql";
import w from "highlight.js/lib/languages/yaml";
import x from "highlight.js/lib/languages/json";
import j from "highlight.js/lib/languages/diff";
import N from "highlight.js/lib/languages/xml";
import { injectGlobal as C, css as O, cx as S } from "@leafygreen-ui/emotion";
import { palette as L, uiColors as A } from "@leafygreen-ui/palette";
import P, { createContext as M, useContext as D, useMemo as I, useState as T, useEffect as E, useRef as B } from "react";
import q from "prop-types";
import W from "clipboard";
import z from "lodash/debounce";
import { usePrevious as R, useIsomorphicLayoutEffect as F } from "@leafygreen-ui/hooks";
import { spacing as _, fontFamilies as Z } from "@leafygreen-ui/tokens";
import { useBaseFontSize as J, usePopoverPortalContainer as G, useUsingKeyboardContext as K } from "@leafygreen-ui/leafygreen-provider";
import H from "highlight.js/lib/core";
import U from "highlightjs-graphql";
import { transparentize as X } from "polished";
import Y from "lodash/flatMap";
import { jsx as $ } from "@emotion/react";
import { VisuallyHidden as Q } from "@leafygreen-ui/a11y";
import V from "@leafygreen-ui/icon/dist/Checkmark";
import nn from "@leafygreen-ui/icon/dist/Copy";
import rn from "@leafygreen-ui/icon-button";
import { isComponentType as en } from "@leafygreen-ui/lib";
import { isComponentGlyph as tn } from "@leafygreen-ui/icon";
import on from "@leafygreen-ui/button";
import { Select as an, Option as ln } from "@leafygreen-ui/select";

function gn(n, r) {
  var e = Object.keys(n);

  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(n);
    r && (t = t.filter(function (r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    })), e.push.apply(e, t);
  }

  return e;
}

function hn(n) {
  for (var r = 1; r < arguments.length; r++) {
    var e = null != arguments[r] ? arguments[r] : {};
    r % 2 ? gn(Object(e), !0).forEach(function (r) {
      cn(n, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : gn(Object(e)).forEach(function (r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }

  return n;
}

function sn(n) {
  return sn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
    return typeof n;
  } : function (n) {
    return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, sn(n);
}

function cn(n, r, e) {
  return r in n ? Object.defineProperty(n, r, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[r] = e, n;
}

function dn() {
  return dn = Object.assign || function (n) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];

      for (var t in e) {
        Object.prototype.hasOwnProperty.call(e, t) && (n[t] = e[t]);
      }
    }

    return n;
  }, dn.apply(this, arguments);
}

function un(n, r) {
  if (null == n) return {};

  var e,
      t,
      i = function (n, r) {
    if (null == n) return {};
    var e,
        t,
        i = {},
        o = Object.keys(n);

    for (t = 0; t < o.length; t++) {
      e = o[t], r.indexOf(e) >= 0 || (i[e] = n[e]);
    }

    return i;
  }(n, r);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);

    for (t = 0; t < o.length; t++) {
      e = o[t], r.indexOf(e) >= 0 || Object.prototype.propertyIsEnumerable.call(n, e) && (i[e] = n[e]);
    }
  }

  return i;
}

function pn(n, r) {
  return r || (r = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}

function fn(n, r) {
  return function (n) {
    if (Array.isArray(n)) return n;
  }(n) || function (n, r) {
    var e = null == n ? null : "undefined" != typeof Symbol && n[Symbol.iterator] || n["@@iterator"];
    if (null == e) return;
    var t,
        i,
        o = [],
        a = !0,
        l = !1;

    try {
      for (e = e.call(n); !(a = (t = e.next()).done) && (o.push(t.value), !r || o.length !== r); a = !0) {
        ;
      }
    } catch (n) {
      l = !0, i = n;
    } finally {
      try {
        a || null == e.return || e.return();
      } finally {
        if (l) throw i;
      }
    }

    return o;
  }(n, r) || bn(n, r) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function mn(n) {
  return function (n) {
    if (Array.isArray(n)) return yn(n);
  }(n) || function (n) {
    if ("undefined" != typeof Symbol && null != n[Symbol.iterator] || null != n["@@iterator"]) return Array.from(n);
  }(n) || bn(n) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function bn(n, r) {
  if (n) {
    if ("string" == typeof n) return yn(n, r);
    var e = Object.prototype.toString.call(n).slice(8, -1);
    return "Object" === e && n.constructor && (e = n.constructor.name), "Map" === e || "Set" === e ? Array.from(n) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? yn(n, r) : void 0;
  }
}

function yn(n, r) {
  (null == r || r > n.length) && (r = n.length);

  for (var e = 0, t = new Array(r); e < r; e++) {
    t[e] = n[e];
  }

  return t;
}

var vn,
    kn = {
  javascript: n,
  typescript: r,
  csharp: e,
  go: t,
  http: i,
  ini: o,
  java: a,
  perl: l,
  php: g,
  properties: h,
  python: s,
  ruby: c,
  rust: d,
  scala: u,
  swift: p,
  kotlin: f,
  objectivec: m,
  dart: b,
  bash: y,
  shell: v,
  sql: k,
  yaml: w,
  json: x,
  diff: j,
  xml: N
},
    wn = {
  JavaScript: "javascript",
  JS: "js",
  TypeScript: "typescript",
  TS: "ts",
  Csharp: "csharp",
  Cs: "cs",
  Go: "go",
  Http: "http",
  Ini: "ini",
  Java: "java",
  Perl: "perl",
  Php: "php",
  Properties: "properties",
  Python: "python",
  Ruby: "ruby",
  Rust: "rust",
  Scala: "scala",
  Swift: "swift",
  Kotlin: "kotlin",
  ObjectiveC: "objectivec",
  Dart: "dart",
  Bash: "bash",
  Shell: "shell",
  Sql: "sql",
  Yaml: "yaml",
  Json: "json",
  Graphql: "graphql",
  Diff: "diff",
  Xml: "xml"
},
    xn = {
  Light: "light",
  Dark: "dark"
},
    jn = hn(hn({}, wn), {}, {
  None: "none"
}),
    Nn = (cn(vn = {}, xn.Light, {
  0: L.gray.light3,
  1: L.gray.light2,
  2: L.gray.dark2,
  3: L.black,
  4: L.white,
  5: "#D83713",
  6: "#956d00",
  7: "#12824D",
  8: "#007ab8",
  9: "#016ee9",
  10: "#CC3887"
}), cn(vn, xn.Dark, {
  0: A.black,
  1: A.gray.dark3,
  2: "#919DA1",
  3: A.gray.light3,
  4: A.gray.dark2,
  5: "#FF6F44",
  6: "#EDB210",
  7: "#35DE7B",
  8: "#a5e3ff",
  9: "#2dc4ff",
  10: "#FF7DC3"
}), vn);

function Cn() {
  Object.values(xn).forEach(function (n) {
    return C(function (n) {
      return "\n  .lg-highlight-hljs-".concat(n, " {\n    \n    .lg-highlight-keyword,\n    .lg-highlight-keyword.lg-highlight-function,\n    .lg-highlight-keyword.lg-highlight-class,\n    .lg-highlight-selector-tag,\n    .lg-highlight-selector-attr,\n    .lg-highlight-selector-pseudo,\n    .lg-highlight-selector-id,\n    .lg-highlight-selector-class {\n      color: ").concat(Nn[n][10], ";\n    }\n\n    .lg-highlight-regexp,\n    .lg-highlight-number,\n    .lg-highlight-literal,\n    .lg-highlight-function.lg-highlight-title {\n      color: ").concat(Nn[n][9], ";\n    }\n\n    .lg-highlight-quote,\n    .lg-highlight-section,\n    .lg-highlight-name {\n      color: ").concat(Nn[n][8], ";\n    }\n\n    .lg-highlight-string,\n    .lg-highlight-addition {\n      color: ").concat(Nn[n][7], ";\n    }\n\n    .lg-highlight-meta,\n    .lg-highlight-meta-string {\n      color: ").concat(Nn[n][6], ";\n    }\n\n    .lg-highlight-variable,\n    .lg-highlight-deletion,\n    .lg-highlight-symbol,\n    .lg-highlight-bullet,\n    .lg-highlight-meta,\n    .lg-highlight-link,\n    .lg-highlight-attr,\n    .lg-highlight-attribute,\n    .lg-highlight-language,\n    .lg-highlight-template-variable,\n    .lg-highlight-built_in,\n    .lg-highlight-type,\n    .lg-highlight-params {\n      color: ").concat(Nn[n][5], "\n    }\n\n    .lg-highlight-title,\n    .lg-highlight-class.lg-highlight-title {\n      color: ").concat(Nn[n][3], ";\n    }\n\n    .lg-highlight-doctag,\n    .lg-highlight-formula {\n      color: ").concat(Nn[n][3], ";\n    }\n  \n    .lg-highlight-comment {\n      color: ").concat(Nn[n][2], ";\n      font-style: italic;\n    }\n  \n    .lg-highlight-string {\n      font-weight: 600;\n    }\n    \n    .lg-highlight-emphasis {\n      font-style: italic;\n    }\n  \n    .lg-highlight-strong {\n      font-weight: bold;\n    }\n  }\n");
    }(n));
  });
}

var On,
    Sn,
    Ln,
    An,
    Pn = M({
  highlightLines: [],
  darkMode: !1
});

function Mn() {
  for (var n = "lg-highlight-", r = arguments.length, e = new Array(r), t = 0; t < r; t++) {
    e[t] = arguments[t];
  }

  return e.filter(function (n) {
    return Bn(n) && n.length > 0;
  }).map(function (r) {
    return r.startsWith(n) ? r : r.split(".").map(function (r) {
      return "".concat(n).concat(r);
    }).join(" ");
  }).join(" ");
}

function Dn() {
  for (var n = ["function", "class"], r = arguments.length, e = new Array(r), t = 0; t < r; t++) {
    e[t] = arguments[t];
  }

  return e.filter(function (r) {
    return n.includes(r);
  });
}

function In(n) {
  var r = n.kind,
      e = n.children;
  return $("span", {
    className: r
  }, e);
}

function Tn(n) {
  return null != n && n instanceof Array;
}

function En(n) {
  return null != n && "object" === sn(n) && !(n instanceof Array);
}

function Bn(n) {
  return null != n && "string" == typeof n;
}

function qn(n, r) {
  return null == n ? null : Bn(n) ? n : Tn(n) ? n.map(qn) : En(n) ? $(In, {
    key: r,
    kind: n.kind
  }, qn(n.children)) : n;
}

var Wn = O(On || (On = pn(["\n  border-spacing: 0;\n  vertical-align: top;\n  padding: 0 ", "px;\n"])), _[3]);

function zn(n) {
  var r, e, t;
  return n ? (r = "transparent", e = "linear-gradient(90deg, ".concat(A.gray.dark3, ", ").concat(X(100, A.gray.dark3), ")"), t = A.gray.dark3) : (r = A.yellow.light3, e = "none", t = A.yellow.light2), O(Sn || (Sn = pn(["\n    background-color: ", ";\n    background-image: ", ";\n    // Fixes an issue in Safari where the gradient applied to the table row would be applied\n    // to each cell in the row instead of being continuous across cells.\n    background-attachment: fixed;\n\n    // Selects all children of a highlighted row, and adds a border top\n    & > td {\n      border-top: 1px solid ", ";\n    }\n\n    // Selects following rows after a highlighted row, and adds a border top\n    // We don't add border bottoms here to support consecutive highlighted rows.\n    & + tr > td {\n      border-top: 1px solid ", ";\n    }\n\n    // Remove borders between consecutive highlighted rows\n    & + & > td {\n      border-top: 0;\n    }\n\n    // If the highlighted row is the last child, then we add a border bottom\n    &:last-child > td {\n      border-bottom: 1px solid ", ";\n    }\n  "])), r, e, t, t, t);
}

function Rn(n) {
  var r = n.lineNumber,
      e = n.highlighted,
      t = n.darkMode,
      i = n.children,
      o = t ? A.gray.dark1 : L.gray.dark1,
      a = t ? A.gray.light2 : L.yellow.dark2;
  return $("tr", {
    className: S(cn({}, zn(t), e))
  }, r && $("td", {
    className: S(Wn, O(Ln || (Ln = pn(["\n              user-select: none;\n              text-align: right;\n              padding-left: ", "px;\n              padding-right: 0;\n              color: ", ";\n            "])), _[2], e ? a : o))
  }, r), $("td", {
    className: Wn
  }, i));
}

function Fn(n) {
  var r = (null != n ? n : {}).children;
  return !(!Tn(r) || 1 !== r.length || !Bn(r[0]));
}

function _n(n, r) {
  if ("string" == typeof n) return n;
  if (null != (e = n) && "object" === sn(e) && "string" == typeof e.kind && e.children instanceof Array) return _n(n.children, r);
  var e;
  return Y(n, function n() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
      t[i] = arguments[i];
    }

    return t = t.filter(function (n) {
      return Bn(n) && n.length > 0;
    }), function (e) {
      var i, o;
      return Bn(e) ? t.length > 0 ? {
        kind: Mn.apply(void 0, [r].concat(mn(t), mn(Dn(e)))),
        children: [e]
      } : e : (null !== (i = null == e || null === (o = e.children) || void 0 === o ? void 0 : o.length) && void 0 !== i ? i : 0) >= 1 ? Y(e.children, n.apply(void 0, [r, e.kind].concat(mn(t)))) : Fn(e) ? {
        kind: Mn.apply(void 0, [r, e.kind].concat(mn(t), mn(Dn.apply(void 0, mn(e.children))))),
        children: e.children
      } : e;
    };
  }(r));
}

function Zn(n) {
  return Tn(n) ? n.some(Zn) : Bn(n) ? n.includes("\n") : !!En(n) && ((null === (r = n.children) || void 0 === r ? void 0 : r.includes("\n")) || Bn(null === (e = n.children) || void 0 === e ? void 0 : e[0]) && n.children[0].includes("\n"));
  var r, e;
}

function Jn(n) {
  var r = [],
      e = 0;
  null == r[e] && (r[e] = []);

  var t = function t() {
    e++, r[e] = [];
  };

  return _n(n).forEach(function (n) {
    Zn(n) ? Bn(n) ? n.split("\n").forEach(function (n, i) {
      i > 0 && t(), n && r[e].push(n);
    }) : n.children[0].split("\n").forEach(function (i, o) {
      o > 0 && t(), r[e].push({
        kind: n.kind,
        children: [i]
      });
    }) : n && (Bn(n) || Fn(n)) && r[e].push(n);
  }), r;
}

function Gn(n) {
  for (var r = n.lines, e = D(Pn), t = e.highlightLines, i = e.showLineNumbers, o = e.darkMode, a = e.lineNumberStart, l = mn(r); 0 === (null === (g = l[0]) || void 0 === g ? void 0 : g.length);) {
    var g;
    l.shift();
  }

  for (; 0 === (null === (h = l[l.length - 1]) || void 0 === h ? void 0 : h.length);) {
    var h;
    l.pop();
  }

  return $(P.Fragment, null, l.map(function (n, r) {
    var e,
        l = r + (null != a ? a : 1),
        g = function (n) {
      return t.some(function (r) {
        if (null != (e = r) && "number" == typeof e) return n === r;
        var e;

        if (Tn(r)) {
          var t = mn(r).sort(function (n, r) {
            return n - r;
          });
          return n >= t[0] && n <= t[1];
        }

        return !1;
      });
    }(l);

    i && (e = l);
    var h = null != n && n.length ? n.map(qn) : $("div", {
      className: O(An || (An = pn(["\n              display: inline-block;\n            "])))
    });
    return $(Rn, {
      key: l,
      lineNumber: e,
      darkMode: o,
      highlighted: g
    }, h);
  }));
}

var Kn,
    Hn,
    Un,
    Xn = {
  "after:highlight": function afterHighlight(n) {
    var r = n._emitter.rootNode;
    n.react = $(Gn, {
      lines: Jn(r.children)
    });
  }
},
    Yn = ["children", "language", "darkMode", "showLineNumbers", "lineNumberStart", "highlightLines", "className"];

function $n(n) {
  return "cs" !== n && "js" !== n && "ts" !== n;
}

var Qn = !1;
var Vn,
    nr,
    rr,
    er = O(Kn || (Kn = pn(["\n  color: inherit;\n  font-size: 13px;\n  font-family: ", ";\n  line-height: 24px;\n"])), Z.code);

function tr(n) {
  var r = n.children,
      e = n.language,
      t = n.darkMode,
      i = void 0 !== t && t,
      o = n.showLineNumbers,
      a = void 0 !== o && o,
      l = n.lineNumberStart,
      g = n.highlightLines,
      h = void 0 === g ? [] : g,
      s = n.className,
      c = un(n, Yn);
  Qn || function () {
    Qn = !0, Cn();
    var n = Object.values(wn).filter($n);
    n.forEach(function (n) {
      "graphql" === n ? U(H) : H.registerLanguage(n, kn[n]);
    }), H.configure({
      languages: n,
      tabReplace: "  "
    }), H.addPlugin(Xn);
  }();
  var d = I(function () {
    return e === jn.None ? null : H.highlight(r, {
      language: e,
      ignoreIllegals: !0
    });
  }, [e, r]),
      u = null === d ? $(Gn, {
    lines: r.split("\n").map(function (n) {
      return n ? [n] : [];
    })
  }) : d.react,
      p = i ? xn.Dark : xn.Light,
      f = 14 === J() ? 13 : i ? 16 : 15,
      m = O(Hn || (Hn = pn(["\n    font-size: ", "px;\n  "])), f);
  return $(Pn.Provider, {
    value: {
      highlightLines: h,
      showLineNumbers: a,
      lineNumberStart: l,
      darkMode: i
    }
  }, $("code", dn({}, c, {
    className: S("lg-highlight-hljs-".concat(p), er, m, e, s)
  }), $("table", {
    className: O(Un || (Un = pn(["\n            border-spacing: 0;\n            width: 100%;\n          "])))
  }, $("tbody", null, u))));
}

tr.displayName = "Syntax", tr.propTypes = {
  children: q.string.isRequired,
  language: q.oneOf(Object.values(jn)),
  className: q.string,
  darkMode: q.bool,
  showLineNumbers: q.bool,
  lineNumberStart: q.number,
  highlightLines: q.arrayOf(q.oneOfType([q.arrayOf(q.number), q.number]))
};
var ir = O(Vn || (Vn = pn(["\n  color: ", ";\n  background-color: ", ";\n\n  &:focus {\n    color: ", ";\n\n    &:before {\n      background-color: ", ";\n    }\n  }\n\n  &:hover {\n    color: ", ";\n\n    &:before {\n      background-color: ", ";\n    }\n  }\n"])), L.white, L.green.dark1, L.white, L.green.dark1, L.white, L.green.dark1);

function or(n) {
  var r = O(nr || (nr = pn(["\n    align-self: center;\n    color: ", ";\n  "])), L.gray.base),
      e = O(rr || (rr = pn(["\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), A.gray.light2, A.gray.light3, A.gray.dark3);
  return S(r, cn({}, e, n === xn.Dark));
}

function ar(n) {
  var r = n.onCopy,
      e = n.contents,
      t = n.darkMode,
      i = fn(T(!1), 2),
      o = i[0],
      a = i[1],
      l = fn(T(null), 2),
      g = l[0],
      h = l[1],
      s = t ? xn.Dark : xn.Light,
      c = G().portalContainer;
  E(function () {
    if (g) {
      var n = new W(g, {
        text: function text() {
          return e;
        },
        container: c
      });

      if (o) {
        var r = setTimeout(function () {
          a(!1);
        }, 1500);
        return function () {
          return clearTimeout(r);
        };
      }

      return function () {
        return n.destroy();
      };
    }
  }, [g, e, o, c]);
  return $(rn, {
    ref: h,
    darkMode: t,
    "aria-label": "Copy",
    className: S(or(s), cn({}, ir, o)),
    onClick: function onClick(n) {
      n.preventDefault(), r && r(), a(!0);
    }
  }, $(o ? V : nn, null), o && $(Q, {
    role: "alert"
  }, "Copied!"));
}

ar.displayName = "CopyButton";
var lr,
    gr,
    hr,
    sr,
    cr,
    dr,
    ur,
    pr,
    fr,
    mr,
    br,
    yr,
    vr,
    kr,
    wr,
    xr,
    jr,
    Nr,
    Cr = ["className", "children"],
    Or = O(lr || (lr = pn(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n"]))),
    Sr = O(gr || (gr = pn(["\n  // Override default menuButton styles\n  margin-top: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 0px;\n  border: 0;\n  font-size: 12px;\n\n  &:hover,\n  &:focus,\n  &:active {\n    box-shadow: 0 0 0 0;\n    border: 0;\n  }\n\n  // Override button defaults\n  > *:last-child {\n    grid-template-columns: 16px 1fr 16px;\n    padding: 0 12px;\n    > svg {\n      width: 16px;\n      height: 16px;\n    }\n  }\n"]))),
    Lr = {
  light: O(hr || (hr = pn(["\n    background-color: ", ";\n    border-right: 1px solid ", ";\n    box-shadow: 0 0 0 0;\n    font-family: ", ";\n\n    &:hover,\n    &:active,\n    &:focus {\n      border-right: 1px solid ", ";\n    }\n\n    &:hover {\n      background-color: ", ";\n    }\n  "])), L.white, L.gray.light2, Z.default, L.gray.light2, L.gray.light2),
  dark: O(sr || (sr = pn(["\n    background-color: ", ";\n    border-right: 1px solid ", ";\n    font-family: ", ";\n\n    &:hover,\n    &:focus,\n    &:active {\n      border-right: 1px solid ", ";\n    }\n\n    &:hover,\n    &:active {\n      background-color: ", ";\n    }\n  "])), A.gray.dark2, A.gray.dark3, Z.legacy, A.gray.dark2, A.gray.dark1)
},
    Ar = {
  light: O(cr || (cr = pn(["\n    &:focus {\n      background-color: ", ";\n    }\n  "])), L.blue.light2),
  dark: O(dr || (dr = pn(["\n    &:focus {\n      background-color: ", ";\n    }\n  "])), A.focus)
},
    Pr = O(ur || (ur = pn(["\n  min-width: 144px;\n  height: 100%;s\n"]))),
    Mr = O(pr || (pr = pn(["\n  margin-right: ", "px;\n"])), _[3]);

function Dr(n) {
  var r,
      e = n.language,
      t = n.languageOptions,
      i = n.onChange,
      o = n.darkMode,
      a = n.usePortal,
      l = n.portalClassName,
      g = n.portalContainer,
      h = n.scrollContainer,
      s = n.popoverZIndex,
      c = K().usingKeyboard,
      d = o ? "dark" : "light",
      u = R(e),
      p = S(Mr, O(fr || (fr = pn(["\n      color: ", ";\n    "])), o ? A.white : A.gray.dark1)),
      f = $(nn, {
    className: p
  });
  null != e.image && (r = e.image, f = tn(r) || en(r, "Icon") ? P.cloneElement(e.image, {
    className: p
  }) : P.cloneElement(e.image, {
    className: Mr
  }));
  var m = P.forwardRef(function (n, r) {
    var e,
        t = n.className,
        i = n.children,
        a = un(n, Cr);
    return $(on, dn({}, a, {
      className: S(t, Sr, Lr[d], (e = {}, cn(e, Ar[d], c), cn(e, O(mr || (mr = pn(["\n            font-family: ", ";\n            font-size: 14px;\n          "])), Z.legacy), o), e)),
      darkMode: o,
      ref: r,
      leftGlyph: f
    }), i);
  }),
      b = {
    popoverZIndex: s,
    usePortal: a,
    portalClassName: l,
    portalContainer: g,
    scrollContainer: h
  };
  return $("div", {
    className: Or
  }, $(an, dn({
    darkMode: o,
    onChange: function onChange(n) {
      if ("" === n && void 0 !== u) return i(u);
      var r = t.find(function (r) {
        return r.displayName === n;
      });
      void 0 !== r && i(r);
    },
    "aria-labelledby": "Language Picker",
    value: null == e ? void 0 : e.displayName,
    className: Pr,
    allowDeselect: !1
  }, b, {
    __INTERNAL__menuButtonSlot__: m
  }), null == t ? void 0 : t.map(function (n) {
    return $(ln, {
      key: null == n ? void 0 : n.displayName,
      value: null == n ? void 0 : n.displayName
    }, null == n ? void 0 : n.displayName);
  })));
}

function Ir(n, r) {
  var e = O(vr || (vr = pn(["\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    flex-shrink: 0;\n    gap: ", "px;\n    padding: 6px;\n    border-left: solid 1px;\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n  "])), _[1]),
      t = O(kr || (kr = pn(["\n    flex-direction: row;\n    border-left: unset;\n    border-bottom: 1px solid;\n    justify-content: space-between;\n    padding: 0;\n    padding-right: 8px;\n    height: 40px; // 28px (icon) + 2 x 6px (focus shadow). Can't use padding b/c switcher\n  "])));
  return S(e, cn({}, t, r), function (n) {
    switch (n) {
      case xn.Light:
        return O(br || (br = pn(["\n        background-color: ", ";\n        border-color: ", ";\n      "])), L.white, L.gray.light2);

      case xn.Dark:
        return O(yr || (yr = pn(["\n        // TODO: Refresh - update these colors\n        background-color: ", ";\n        border-color: ", ";\n      "])), A.gray.dark2, A.gray.dark3);
    }
  }(n));
}

function Tr(n) {
  var r = n.language,
      e = n.languageOptions,
      t = n.contents,
      i = n.onChange,
      o = n.onCopy,
      a = n.showCopyButton,
      l = n.darkMode,
      g = n.customActionButtons,
      h = n.showCustomActionButtons,
      s = n.usePortal,
      c = n.portalClassName,
      d = n.portalContainer,
      u = n.scrollContainer,
      p = n.popoverZIndex,
      f = n.className,
      m = {
    popoverZIndex: p,
    usePortal: s,
    portalClassName: c,
    portalContainer: d,
    scrollContainer: u
  };
  return $("div", {
    className: S(Ir(l ? xn.Dark : xn.Light, !!r), f),
    "data-testid": "leafygreen-code-panel"
  }, void 0 !== r && void 0 !== e && void 0 !== i && $(Dr, dn({
    onChange: i,
    language: r,
    languageOptions: e,
    darkMode: l
  }, m)), a && $(ar, {
    onCopy: o,
    darkMode: l,
    contents: t,
    withLanguageSwitcher: !!r
  }), h && $(P.Fragment, null, null == g ? void 0 : g.map(function (n) {
    return n;
  })));
}

Dr.displayName = "LanguageSwitcher", Tr.displayName = "Panel";
var Er = "light",
    Br = "dark",
    qr = O(wr || (wr = pn(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ", "px;\n  padding-left: ", "px;\n  padding-right: ", "px;\n  border-radius: ", "px ", "px 0 0;\n  font-family: ", ";\n"])), 28, 12, 12, 4, 4, Z.default),
    Wr = O(xr || (xr = pn(["\n  padding-left: ", "px;\n  padding-right: ", "px;\n  font-size: 14px;\n"])), 8, 8);

function zr(n) {
  var r = n.darkMode,
      e = void 0 !== r && r,
      t = n.chromeTitle,
      i = void 0 === t ? "" : t,
      o = Nn[e ? Br : Er];
  return $("div", {
    className: S(qr, O(jr || (jr = pn(["\n          background-color: ", ";\n          color: ", ";\n        "])), o[1], o[2]), cn({}, O(Nr || (Nr = pn(["\n            font-family: ", ";\n          "])), Z.legacy), e))
  }, $("div", {
    className: Wr
  }, i));
}

zr.displayName = "WindowChrome", zr.propTypes = {
  darkMode: q.bool,
  chromeTitle: q.string
};

var Rr,
    Fr,
    _r,
    Zr,
    Jr,
    Gr,
    Kr,
    Hr,
    Ur,
    Xr,
    Yr,
    $r,
    Qr,
    Vr,
    ne,
    re,
    ee,
    te,
    ie = ["children", "className", "language", "darkMode", "showLineNumbers", "lineNumberStart", "showWindowChrome", "chromeTitle", "copyable", "onCopy", "highlightLines", "languageOptions", "onChange", "customActionButtons", "showCustomActionButtons", "usePortal", "portalClassName", "portalContainer", "scrollContainer", "popoverZIndex"];

var oe = function (n) {
  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      e = r.literal,
      t = r.overlap,
      i = e ? n : ["&"].concat(n);

  function o(n) {
    if ("object" != typeof n || null == n) return [];
    if (Array.isArray(n)) return n.map(o);
    var r = {},
        a = {},
        l = {};
    return Object.keys(n).forEach(function (g) {
      var h = n[g];

      if (!Array.isArray(h) && e && (h = [h]), (e || Array.isArray(h)) && 38 !== g.charCodeAt(0)) {
        var s = void 0;
        h.forEach(function (n, o) {
          if ((!t || s !== n) && null != n) if (s = n, 0 !== o || e) {
            if (void 0 === r[i[o]]) {
              var a;
              r[i[o]] = ((a = {})[g] = n, a);
            } else r[i[o]][g] = n;
          } else l[g] = n;
        });
      } else "object" == typeof h ? a[g] = o(h) : l[g] = h;
    }), i.forEach(function (n) {
      r[n] && (l[n] = r[n]);
    }), Object.assign(l, a), l;
  }

  return function () {
    for (var n = arguments.length, r = Array(n), e = 0; e < n; e++) {
      r[e] = arguments[e];
    }

    return r.map(o);
  };
}(["@media only screen and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 2)", "@media only screen and (min-device-width: 813px) and (-webkit-min-device-pixel-ratio: 2)"]),
    ae = (cn(_r = {}, xn.Light, O(Rr || (Rr = pn(["\n    border: 1px solid ", ";\n    border-radius: 12px;\n    overflow: hidden;\n  "])), Nn[xn.Light][1])), cn(_r, xn.Dark, O(Fr || (Fr = pn(["\n    border: 0;\n    border-radius: 6px;\n    overflow: hidden;\n  "])))), _r),
    le = O(Zr || (Zr = pn(["\n  position: relative;\n  display: grid;\n  grid-template-areas: 'code panel';\n  grid-template-columns: auto 38px;\n  border-radius: inherit;\n  z-index: 0; // new stacking context\n"]))),
    ge = O(Jr || (Jr = pn(["\n  // No panel with chrome\n  grid-template-areas: 'code code';\n"]))),
    he = O(Gr || (Gr = pn(["\n  grid-template-areas: 'panel' 'code';\n  grid-template-columns: unset;\n"]))),
    se = O(Kr || (Kr = pn(["\n  grid-area: code;\n  overflow-x: auto;\n  // Many applications have global styles that are adding a border and border radius to this element.\n  border-radius: inherit;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border: 0;\n  // We apply left / right padding in Syntax to support line highlighting\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n  margin: 0;\n  position: relative;\n  transition: box-shadow 100ms ease-in-out;\n\n  ", "\n"])), _[2], _[2], oe({
  whiteSpace: ["pre", "pre-wrap", "pre"]
})),
    ce = O(Hr || (Hr = pn(["\n  border-left: 0;\n  border-radius: inherit;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n"]))),
    de = O(Ur || (Ur = pn(["\n  border-left: 0;\n  border-radius: inherit;\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n"]))),
    ue = O(Xr || (Xr = pn(["\n  display: flex;\n  align-items: center;\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n"])), 6, 6),
    pe = O(Yr || (Yr = pn(["\n  &:focus,\n  &:active,\n  &:focus-visible,\n  &:focus-within {\n    outline: none;\n    box-shadow: 0 0 0 2px ", " inset;\n  }\n"])), L.blue.light1),
    fe = O($r || ($r = pn(["\n  z-index: 2; // Above the shadows\n  grid-area: panel;\n"])));

function me(n) {
  var r = Nn[n],
      e = "dark" === n ? "border: 0" : "border-color: ".concat(r[1]);
  return O(Qr || (Qr = pn(["\n    ", ";\n    background-color: ", ";\n    color: ", ";\n  "])), e, r[0], r[3]);
}

var be = "none",
    ye = "left",
    ve = "right",
    ke = "both",
    we = O(Vr || (Vr = pn(["\n  &:before,\n  &:after {\n    content: '';\n    display: block;\n    position: absolute;\n    z-index: 1; // above the code\n    top: 0;\n    height: 100%;\n    width: 8px;\n    border-radius: 100%;\n    box-shadow: unset;\n    transition: box-shadow 100ms ease-in-out;\n  }\n  &:before {\n    grid-column: 1;\n    left: -8px;\n  }\n  &:after {\n    grid-column: 2; // Placed either under Panel, or on the right edge\n  }\n"]))),
    xe = O(ne || (ne = pn(["\n  &:after {\n    grid-column: 3; // Placed on the right edge\n  }\n"]))),
    je = O(re || (re = pn(["\n  &:before,\n  &:after {\n    grid-row: 2; // Placed on the right edge\n  }\n"])));

function Ne(n, r) {
  var e = X(.7, r === xn.Light ? L.gray.dark1 : A.black),
      t = O(ee || (ee = pn(["\n    box-shadow: 0 0 10px 0 ", ";\n  "])), e);
  return O(te || (te = pn(["\n    &:before {\n      ", ";\n    }\n    &:after {\n      ", ";\n    }\n  "])), (n === ke || n === ye) && t, (n === ke || n === ve) && t);
}

function Ce(n) {
  var r,
      e,
      t = n.children,
      i = void 0 === t ? "" : t,
      o = n.className,
      a = n.language,
      l = n.darkMode,
      g = void 0 !== l && l,
      h = n.showLineNumbers,
      s = void 0 !== h && h,
      c = n.lineNumberStart,
      d = void 0 === c ? 1 : c,
      u = n.showWindowChrome,
      p = void 0 !== u && u,
      f = n.chromeTitle,
      m = void 0 === f ? "" : f,
      b = n.copyable,
      y = void 0 === b || b,
      v = n.onCopy,
      k = n.highlightLines,
      w = void 0 === k ? [] : k,
      x = n.languageOptions,
      j = n.onChange,
      N = n.customActionButtons,
      C = void 0 === N ? [] : N,
      O = n.showCustomActionButtons,
      L = void 0 !== O && O,
      A = n.usePortal,
      P = void 0 === A || A,
      M = n.portalClassName,
      D = n.portalContainer,
      q = n.scrollContainer,
      R = n.popoverZIndex,
      _ = un(n, ie),
      Z = B(null),
      J = K().usingKeyboard,
      G = fn(T(be), 2),
      H = G[0],
      U = G[1],
      X = fn(T(!1), 2),
      Y = X[0],
      Q = X[1],
      V = g ? xn.Dark : xn.Light,
      nn = I(function () {
    return i.trim().includes("\n");
  }, [i]),
      rn = C.filter(function (n) {
    return !0 === en(n, "IconButton");
  }),
      tn = L && !!rn.length,
      on = null == x ? void 0 : x.find(function (n) {
    return n.displayName === a;
  }),
      an = on ? on.language : a,
      ln = !!on;

  E(function () {
    Q(y && W.isSupported());
  }, [y, p]), F(function () {
    var n = Z.current;
    null != n && n.scrollWidth > n.clientWidth && U(ve);
  }, []);
  var gn = $(tr, {
    showLineNumbers: s,
    lineNumberStart: d,
    darkMode: g,
    language: an,
    highlightLines: w
  }, i);
  var sn = z(function (n) {
    var r = n.target,
        e = r.scrollWidth,
        t = r.clientWidth;

    if (e > t) {
      var i = n.target.scrollLeft,
          o = e - t;
      i > 0 && i < o ? U(ke) : i > 0 ? U(ye) : i < o && U(ve);
    }
  }, 50, {
    leading: !0
  }),
      pn = hn({
    popoverZIndex: R
  }, P ? {
    usePortal: P,
    portalClassName: M,
    portalContainer: D,
    scrollContainer: q
  } : {
    usePortal: P
  });
  return $("div", {
    className: ae[V]
  }, p && $(zr, {
    chromeTitle: m,
    darkMode: g
  }), $("div", {
    className: S(le, we, Ne(H, V), (r = {}, cn(r, ge, p), cn(r, he, ln), cn(r, xe, p), cn(r, je, ln), r), we, Ne(H, V))
  }, $("pre", dn({}, _, {
    className: S(se, me(V), (e = {}, cn(e, ce, p), cn(e, de, ln), cn(e, ue, !nn), cn(e, pe, J), e), o),
    onScroll: function onScroll(n) {
      n.persist(), sn(n);
    },
    ref: Z,
    tabIndex: H !== be ? 0 : -1
  }), gn), !p && (y || !!on || tn) && $(Tr, dn({
    className: S(fe),
    language: on,
    languageOptions: x,
    onChange: j,
    contents: i,
    onCopy: v,
    showCopyButton: Y,
    darkMode: g,
    isMultiline: nn,
    customActionButtons: rn,
    showCustomActionButtons: tn
  }, pn))));
}

Ce.displayName = "Code", Ce.propTypes = {
  children: q.string.isRequired,
  language: q.oneOfType([q.oneOf(Object.values(jn)), q.string]),
  darkMode: q.bool,
  className: q.string,
  showLineNumbers: q.bool,
  lineNumberStart: q.number,
  showWindowChrome: q.bool,
  chromeTitle: q.string,
  highlightLines: q.arrayOf(q.oneOfType([q.arrayOf(q.number), q.number]))
};
export { jn as Language, xn as Mode, Ce as default, Nn as variantColors };